var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 4,
    fill: "#3B6274",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.833496,
    y: 1,
    width: 55,
    height: 55,
    rx: 3.5,
    stroke: "#3B6274",
    strokeOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0015 17H40.0015V22.8467H37.3348V19.6667H18.6681V31.6667H24.4455V34.3333H16.0015V17Z",
    fill: "#3B6274"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9134 26.7212C30.0788 27.9545 31.0721 29.0052 33.3348 29.0052H36.0014C36.7087 29.0052 37.3869 29.2862 37.887 29.7863C38.3871 30.2864 38.6681 30.9646 38.6681 31.6719V33.0052C38.6681 33.4733 38.5449 33.9331 38.3108 34.3385C38.0768 34.7439 37.7401 35.0805 37.3348 35.3145V42.3385H33.3348V31.6719C29.8454 31.6719 28.0601 29.7385 26.8814 28.4652C26.7216 28.2897 26.5585 28.1172 26.3921 27.9479L28.2774 26.0625C28.4988 26.2848 28.7108 26.5043 28.9134 26.7212ZM37.3348 25.6719C37.3348 26.2023 37.124 26.711 36.749 27.0861C36.3739 27.4612 35.8652 27.6719 35.3348 27.6719C34.8043 27.6719 34.2956 27.4612 33.9205 27.0861C33.5455 26.711 33.3348 26.2023 33.3348 25.6719C33.3348 25.1414 33.5455 24.6327 33.9205 24.2577C34.2956 23.8826 34.8043 23.6719 35.3348 23.6719C35.8652 23.6719 36.3739 23.8826 36.749 24.2577C37.124 24.6327 37.3348 25.1414 37.3348 25.6719Z",
    fill: "#3B6274"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdTitleIcon);
export default __webpack_public_path__ + "static/media/third-title-icon.24e5fa34744de9a0e9174234c61555ba.svg";
export { ForwardRef as ReactComponent };